<template>
  <div style="background-color: #fff;margin:24px">
    <top-title
      name="优惠券管理"
      @myEvent="setCoupon"
      pageName="忠诚度管理-优惠券管理"
      style=" min-width: 1066px"
    ></top-title>
    <div class="integralEden">
      <div class="content">
        <!-- 头部导航切换 -->
        <!-- <div class="navTab">
          <span class="tab" :class="{ active: tabActive == 1 }" @click="insideBtn">内部优惠券</span>
          <span class="tab" :class="{ active: tabActive == 2 }" @click="external">外部优惠券</span>
        </div> -->
        <div class="card-point tipBg">
          <div class="card-rule" style="width: 60px;font-weight: bold;margin-bottom:6px;">提示：</div>
          <div>
            <div class="card-connet">
            <p>
              1、优惠券当前仅支持创建发放型优惠券，无需用户点击领取，通过活动接口直接发放到用户账户，发放型优惠券不存在被转发或恶意分享的风险；
            </p>
            <p>2、POP店铺创建活动时可直接按需新建直发放型优惠券，无需提前预创建；自营店铺可直接填写优惠券KEY；</p>
            <p>3、因官方接口限制，FCS店铺不支持优惠券奖品，请勿使用优惠券；</p>
            <p style="color:#9061ff;cursor: pointer;" @click="toZyCouponTeach">自营券配置教程>></p>
          </div>
          </div>

        </div>
        <el-tabs v-model="tabActive" type="card" @tab-click="handleClick">
          <el-tab-pane label="优惠券列表" name="1"></el-tab-pane>
          <el-tab-pane label="发放记录" name="2"></el-tab-pane>
        </el-tabs>
        <!-- 发放记录 -->
        <div v-if="tabActive == 2">
          <input-form
            ref="inputForm"
            v-if="tabActive == 2"
            style="margin: 40px 0"
            :inputData="inputData"
            :pageName="pageName"
            :btnPosition1="true"
            @toParentVal="searchContent"
          ></input-form>

          <el-table
            :data="tableData"
            v-loading="tableLoading"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 95%; margin: 0 auto"
          >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="chaosPin" label="用户pin（加密）" width="150" >
            </el-table-column>
            <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
            <el-table-column prop="couponName" label="优惠券名称"> </el-table-column>
            <el-table-column prop="name" label="优惠券信息"> 
              <template slot-scope="scope">
                <span v-if="scope.row.couponKind == 0">全品类,</span>
                <span v-if="scope.row.couponKind == 1">限品类,</span>
                <span v-if="scope.row.couponKind == 2">限店铺,</span>
                <span v-if="scope.row.couponKind == 3">店铺限商品券,</span>
                满{{ scope.row.quota }}减{{ scope.row.discount }}元
              </template>
            </el-table-column>
            <el-table-column prop="activityName" label="关联活动"> </el-table-column>
            <el-table-column prop="activitySubType" label="活动类型">
              <template slot-scope="scope">
                <span v-if="scope.row.activitySubType == 1"> 签到赢好礼 </span>
                <span v-if="scope.row.activitySubType == 2"> 浏览礼品有礼 </span>
                <span v-if="scope.row.activitySubType == 3"> 每日限时抢 </span>
                <span v-if="scope.row.activitySubType == 4"> 关注店铺有礼 </span>
                <span v-if="scope.row.activitySubType == 5"> 邀请开卡有礼 </span>
                <span v-if="scope.row.activitySubType == 6"> 邀请关注有礼 </span>
                <span v-if="scope.row.activitySubType == 7"> 完善信息有礼 </span>
                <span v-if="scope.row.activitySubType == 8"> 幸运抽奖 </span>
                <span v-if="scope.row.activitySubType == 9"> 积分兑换实物 </span>
                <span v-if="scope.row.activitySubType == 10"> 积分兑换优惠券 </span>
                <span v-if="scope.row.activitySubType == 11"> 新人优惠券 </span>
                <span v-if="scope.row.activitySubType == 12"> 会员优惠券 </span>
                <span v-if="scope.row.activitySubType == 13">开卡礼包</span>
                <span v-if="scope.row.activitySubType == 14">店铺礼包</span>
                <span v-if="scope.row.activitySubType == 15">店铺礼包（千人千面）</span>
                <span v-if="scope.row.activitySubType == 16">下单有礼</span>
                <span v-if="scope.row.activitySubType == 17">首单专享礼</span>
                <span v-if="scope.row.activitySubType == 18">复购有礼</span>
                <span v-if="scope.row.activitySubType == 19">下单抽奖</span>
                <span v-if="scope.row.activitySubType == 20">评价有礼</span>
                <span v-if="scope.row.activitySubType == 21">裂变神券</span>
                <span v-if="scope.row.activitySubType == 22">天降红包雨</span>
                <span v-if="scope.row.activitySubType == 23">欢乐娃娃机</span>
                <span v-if="scope.row.activitySubType == 24">大家来找茬</span>
                <span v-if="scope.row.activitySubType == 25">智能活动海报</span>
                <span v-if="scope.row.activitySubType == 26">刮刮乐</span>
                <span v-if="scope.row.activitySubType == 27">预售有礼</span>
                <span v-if="scope.row.activitySubType == 28">预售抽奖</span>
                <span v-if="scope.row.activitySubType == 31">超级裂变券</span>  
                <span v-if="scope.row.activitySubType == 32">会员卡片</span>  
                <span v-if="scope.row.activitySubType == 33">0元试用</span>  
                <span v-if="scope.row.sendSource == 1">叶脉客服工具发放</span>  
              </template>
            </el-table-column>
            <el-table-column prop="sendTime" label="发放时间"> </el-table-column>
            <el-table-column prop="sendStatus" label="发放状态">
              <template slot-scope="scope">
                <span v-if="scope.row.sendStatus == 0">发放成功</span>
                <span v-if="scope.row.sendStatus == 1">发放失败</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="领取时间" width="240">
              <template slot-scope="scope">
                <span>起:{{ scope.row.takeBeginTime }}</span
                ><br />
                <span>止:{{ scope.row.takeEndTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期" width="240">
              <template slot-scope="scope">
                <span>起:{{ scope.row.beginTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="数据统计" width="180">
              <template slot-scope="scope">
                <span>发行量:{{ scope.row.num }}</span> 张<br />
                <span>发券量:{{ scope.row.sendNum }}</span> 张<br />
                <span>用券量:{{ scope.row.usedNum }}</span> 张<br />
                <span style="color: #7f85e9; cursor: pointer" @click="moreStatistics" v-zoom="{ from: pageName, name: '更多统计' }">更多统计</span>
              </template>
            </el-table-column>
            <el-table-column label="面额/使用条件">
              <template slot-scope="scope">
                <span>{{ scope.row.discount }}</span
                >元/ 满<span>{{ scope.row.quota }}</span
                >元
              </template>
            </el-table-column>
            <el-table-column label="推广范围" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.grantType == 1">促销绑定</span>
                <span v-if="scope.row.grantType == 2">推送</span>
                <span v-if="scope.row.grantType == 3">免费领取</span>
                <span v-if="scope.row.grantType == 4">京豆换券</span>
                <span v-if="scope.row.grantType == 5">互动平台 </span>
              </template>
            </el-table-column>
            <el-table-column label="优惠券链接" width="350">
              <template slot-scope="scope">
                无线连接
                <el-input v-model="scope.row.longLinkUrl" readonly style="width: 220px; margin-left: 15px"></el-input><br />
                无线短连接
                <el-input v-model="scope.row.shortLinkUrl" readonly style="width: 220px"></el-input>
              </template>
            </el-table-column> -->
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="formList.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="formList.size"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalList"
          ></el-pagination>
          <div style="color: #7B61FF; padding: 20px 0 20px 40px">
            <!-- 注：此类型奖品暂时不支持自营店铺 -->
          </div>
        </div>

        <!-- 优惠券列表 -->
        <div v-if="tabActive == 1">
          <input-form
            v-if="tabActive == 1"
            ref="inputForms"
            style="margin: 40px 0"
            :inputData="inputDataTwo"
            :btnPosition1="true"
            @toParentVal="searchContentTwo"
          ></input-form>
          <div style="margin: 0px 0px 12px 30px;">
            <el-button v-if="venderType" style="width: auto;background-color:#7b61ff;color:white;border: 1px solid #7b61ff" @click="handleAddCoupon2">添加发放型外部券</el-button>
            <el-button v-else  style="width: auto;background-color:#7b61ff;color:white;border: 1px solid #7b61ff" @click="handleAddCoupon">创建发放型优惠券</el-button>
          </div>
          <el-table
            :data="tableDataTwo"
            v-loading="tableLoading"
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%; margin: 0 auto"
          >
            <template slot="empty">
              <div>
                <img src="https://yeion-public.s3.cn-north-1.jdcloud-oss.com/noData.png" />
                <span style="margin-left: -140px">暂无任何数据</span>
              </div>
            </template>
            <el-table-column prop="name" label="优惠券名称" width="150"> </el-table-column>
            <el-table-column prop="name" label="优惠券信息" width="150"> 
              <template slot-scope="scope">
                <span v-if="scope.row.couponKind == 0">全品类东券,</span>
                <span v-if="scope.row.couponKind == 1">限品类京券,</span>
                <span v-if="scope.row.couponKind == 2">店铺东券,</span>
                <span v-if="scope.row.couponKind == 3">限商品东券,</span>
                满{{ scope.row.quota }}减{{ scope.row.discount }}元
              </template>
            </el-table-column>
            <el-table-column :prop="venderType?'putkey':'couponIdOrPutKey'" label="优惠券id/key" width="150"> </el-table-column>
            <el-table-column prop="createTime" label="创建时间" width="180"> </el-table-column>
            <el-table-column label="领取时间" width="180">
              <template slot-scope="scope">
                <span>起:{{ scope.row.takeBeginTime }}</span
                ><br />
                <span>止:{{ scope.row.takeEndTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="有效期" width="180">
              <template slot-scope="scope">
                  <div v-if="scope.row.validityType == 5">
                    <span>起:{{ scope.row.beginTime }}</span
                    ><br />
                    <span>止:{{ scope.row.endTime }}</span>
                  </div>
                  <div v-else>
                    领取后{{ scope.row.addDays }}天有效
                  </div>
              </template>
            </el-table-column>
            <el-table-column prop="numPerSending" label="单次发放数量" width="130"></el-table-column>
            <el-table-column prop="num" label="总量" width="130"> </el-table-column>
            <el-table-column prop="sendNum" label="已发放数量" width="130"> </el-table-column>
            <el-table-column prop="balanceNum" label="剩余数量" width="130"> </el-table-column>
            <el-table-column prop="status" label="奖品状态" width="130"> 
              <template slot-scope="scope">
                <span v-if="scope.row.status == 1">未开始</span>
                <span v-if="scope.row.status == 2">进行中</span>
                <span v-if="scope.row.status == 3">已结束</span>
              </template>
            </el-table-column>
            <!-- <el-table-column prop="activityName" label="关联活动" width="130"> </el-table-column> -->
            <el-table-column prop="name" label="操作" width="180"> 
              <template slot-scope="scope">
                <span type="text" @click="commentDetails(scope.row)" class="operation">查看</span>
                <span style="margin-left: 8px;" type="text" @click="syncDongdong(scope.row)" v-if="(scope.row.status == 2 || scope.row.status == 1) && scope.row.isMarkDong == 0 && permissions.includes('sync_leaf_vein')" class="operation">同步叶脉</span>
                <span style="margin-left: 8px;" type="text" @click="syncDongdong(scope.row)" v-else-if="scope.row.isMarkDong == 1 && permissions.includes('sync_leaf_vein')" class="operation">撤销同步叶脉</span>
                <span style="margin-left: 8px;color: #999999;cursor: no-drop;" type="text" v-else-if="permissions.includes('sync_leaf_vein')" class="operation">同步叶脉</span>
                <span style="margin-left: 8px;" @click="marketNowActivity(scope.row)" class="operation">关联活动</span>
              </template>
            </el-table-column>
            <!-- <el-table-column label="领取时间">
              <template slot-scope="scope">
                <span>起:{{ scope.row.takeBeginTime }}</span
                ><br />
                <span>止:{{ scope.row.takeEndTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="有效期">
              <template slot-scope="scope">
                <span>起:{{ scope.row.beginTime }}</span
                ><br />
                <span>止:{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column label="面额/使用条件">
              <template slot-scope="scope">
                <span>{{ scope.row.discount }}</span
                >元/ 满<span>{{ scope.row.quota }}</span
                >元
              </template>
            </el-table-column>
            <el-table-column label="发放方式">
              <template slot-scope="scope">
                <span>{{ scope.row.issueType == 1 ? "自动发放" : "免费抢券" }}</span>
              </template>
            </el-table-column>
            <el-table-column label="优惠券链接" width="400">
              <template slot-scope="scope">
                无线连接
                <el-input v-model="scope.row.shortUrl" readonly style="width: 220px; margin-left: 14px"></el-input><br />
                无线短连接
                <el-input v-model="scope.row.url" readonly style="width: 220px"></el-input>
              </template>
            </el-table-column> -->
          </el-table>
          <!-- 分页 -->
          <el-pagination
            background
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :current-page="formListTwo.current"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="formListTwo.size"
            layout="total, sizes, prev, pager, next, jumper"
            class="pagination"
            :total="totalListTwo"
          ></el-pagination>
          <div style="color: #7B61FF; padding: 20px 0 20px 40px">
            <!-- 注：此类型奖品暂时不支持自营店铺 -->
          </div>
        </div>
      </div>
    </div>
    <!-- 添加优惠券弹窗 -->
    <el-dialog title="添加外部优惠券" :visible.sync="dialogFormVisible" :before-close="closeWithoutCoupon">
      <el-form :model="setFormList" label-width="150px">
        <el-form-item label="发放方式:">
          <el-radio-group v-model="setFormList.issueType">
            <el-radio :label="0">免费抢券</el-radio>
            <el-radio :label="1">自动发放</el-radio>
          </el-radio-group>
        </el-form-item>
        <template v-if="setFormList.issueType == 0">
          <el-form-item label="putKey:">
            <el-input v-model="setFormList.putKey" style="width: 300px;margin-right:10px;"></el-input>
            <el-button type="primary" @click="byPutKey">检测可用性</el-button>
            <div style="color:#e2455b;">注：自营商家可自己申请或找采销申请且必须为免费领取型优惠券，复制putKey</div>
          </el-form-item>
          <el-form-item label="优惠券名称:">
            <el-input v-model="setFormList.name" style="width: 300px"></el-input>
          </el-form-item>
          <!-- <el-form-item label="活动配置Key或链接:">
          <el-input
            v-model="setFormList.skuId"
            style="width: 300px; margin-right: 50px"
          ></el-input>
          <el-button type="primary">检查可用性</el-button><br />
          <span style="font-size: 12px; color: #7B61FF"
            >注：商家可自己申请或找采销申请且必须为免费领取型优惠券，复制putKey</span
          >
        </el-form-item> -->
          <el-form-item label="有效期:">
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="setFormList.startTime"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 135px; font-size: 12px"
                @change="TimeSendTimeOne"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="setFormList.endTime"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                @change="TimeSendTimeOne"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
            &nbsp;&nbsp;有效期为：<span style="color: #7B61FF">{{ TimeSendTimeOne1 }} </span>天
          </el-form-item>
          <el-form-item label="领取时间:">
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="setFormList.takeBeginTime"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                @change="TimeSendTimeTwo"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 135px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="setFormList.takeEndTime"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                @change="TimeSendTimeTwo"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime1()"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
            &nbsp;&nbsp;有效期为：<span style="color: #7B61FF">{{ TimeSendTimeTwo1 }} </span>天
          </el-form-item>
          <el-form-item label="优惠券面额:">
            <el-input
              onkeyup="value=value.replace(/[^\d]/g,'')"
              v-model="setFormList.discount"
              @change="discountchange"
              style="width: 300px"
            ></el-input>
            &nbsp;&nbsp;元
          </el-form-item>
          <el-form-item label="参加条件">
            <el-radio-group v-model="resource" @change="resourceChange">
              <el-radio label="无条件"></el-radio>
              <el-radio label="订单满"></el-radio>
              <el-input v-model="quota" onkeyup="value=value.replace(/[^\d]/g,'')" @change="quotaChange" style="width: 150px"></el-input>
              <span>元</span>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="PC端链接:">
            <el-input v-model="setFormList.url" style="width: 300px" @change="urlChange"></el-input>
            &nbsp;&nbsp;外部优惠券链接
          </el-form-item>
          <el-form-item label="无线端链接:">
            <el-input v-model="setFormList.shortUrl" style="width: 300px" @change="shortUrlChange"></el-input>
            &nbsp;&nbsp;PC端链接输入后会自动转化无线端优惠券，请确认是否正确
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="putKey:">
            <el-input v-model="setFormList.putKey" style="width: 300px;margin-right:10px;"></el-input>
            <el-button type="primary" @click="byPutKey">检测可用性</el-button>
            <div style="color:#e2455b;">注：自营商家可自己申请或找采销申请且必须为免费领取型优惠券，复制putKey</div>
          </el-form-item>
          <el-form-item label="优惠券名称:">
            <el-input v-model="setFormList.name" style="width: 300px"></el-input>
          </el-form-item>
        </template>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeWithoutCoupon">取 消</el-button>
        <el-button type="primary" @click="addWithoutCoupon">确 定</el-button>
      </div>
    </el-dialog>

    <add-coupon
      :isSuperFission="true"
      :showButton="showButton"
      :fromInfo="echoDate"
      :isShow="addCouponIsShow"
      :isyouhui="true" 
      @close="addCouponIsShow = false"
      @funcMes="addStatus"
    ></add-coupon>
    <add-coupon2
      :showButton="showButton2"
      :fromInfo="echoDate2"
      :isShow="addCouponIsShow2"
      @close="addCouponIsShow2 = false"
      @funcMes="addStatus2"
    ></add-coupon2>
    <el-dialog
      title="关联活动"
      width="1200px"
      :visible.sync="isShowAssociateActivity"
      @close="isShowAssociateActivity = false"
    >
      <div v-loading="loadingRel">
        <div style="display: flex;align-items: center;">
          <div style="flex: 1;">
            <span>优惠券名称：</span>
            <span>
              {{ couponObj.couponName }}
            </span>
          </div>
          <div style="flex: 1;">
            <span>总量：</span>
            <span>
              {{ couponObj.quantityTotal }}
            </span>
          </div>
          <div style="flex: 1;">
            <span>剩余数量：</span>
            <span>
              {{ couponObj.quantityBalance}}
            </span>
          </div>
        </div>
        <div style="display: flex;align-items: center;margin-top: 20px;">
          <div style="flex: 1;">
            <span>领取时间：</span>
            <span>
              {{ couponObj.startTime }} - {{ couponObj.endTime }}
            </span>
          </div>
          <div style="flex: 1;">
            <span>活动绑定数量：</span>
            <span>
              {{ couponObj.quantityBindingCount || 0 }}
            </span>
          </div>
          <div style="flex: 1;">
            <span>剩余可绑定数量：</span>
            <span>
              {{ couponObj.remainingBindingCount || 0 }}
            </span>
          </div>
        </div>
        <div style="margin-top: 16px;">
          <el-table
            :header-cell-style="{ background: '#fafafa', 'text-align': 'left' }"
            :cell-style="{ 'text-align': 'left' }"
            style="width: 100%; margin: 0 auto"
            :data="couponObj.recordList" 
            max-height="550px"
          >
            <el-table-column label="关联活动" prop="activityName" />
            <el-table-column label="活动时间">
              <template #default="{ row }">
                {{ row.activityStartTime }} - {{ row.activityEndTime }}
              </template>
            </el-table-column>
            <el-table-column label="活动状态">
              <template #default="{ row }">
                <span v-if="row.activityStatus == 1">未开始</span>
                <span v-else-if="row.activityStatus == 2">进行中</span>
                <span v-else-if="row.activityStatus == 3">已结束</span>
                <span v-else-if="row.activityStatus == 6">已暂停</span>
                <span v-else>未知</span>
              </template>
            </el-table-column>
            <el-table-column label="活动绑定数量" prop="quantityBinding" />
            <el-table-column label="剩余数量" prop="quantityBalance" />
            <el-table-column label="关联活动状态">
              <template #default="{ row }">
                {{ row.bindingStatus == 0 ? "使用中" : "已释放库存" }}
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template #default="{ row }">
                <el-button
                  type="text"
                  :disabled="row.activityStatus != 3 || row.bindingStatus == 1"
                  @click="handleRelease(row)"
                >
                  释放剩余库存
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import topTitle from "../../components/top-title";
import inputForm from "../../components/inputForm";
import { couponList } from "@/api/integralCenter/prizeCenter.js";
import { querySellerCouponExternalList, addExternal, byPutKey, externalAuto,couponSendRecord,createSellerCouponWrite ,sellerCouponWriteMarkDong,queryBindingRecord,updateBindingStatus } from "@/api/integralCenter/couponWriteController";
import addCoupon from './add_coupon1.vue'
import addCoupon2 from './add_coupon2.vue'
export default {
  components: {
    topTitle,
    inputForm,
    addCoupon,
    addCoupon2,
  },
  data() {
    return {
      loadingRel: false,
      couponObj: {},
      isShowAssociateActivity: false,
      couponData: {},
      showButton2: true,
      echoDate2: {},
      addCouponIsShow2: false,
      showButton: true,
      indexCoupon: 0,
      FissionVoucherList: [
        // 奖项设置
        // {
        //   title: "",
        //   prizeType: null,
        //   price: null,
        //   totalAmount: null,
        //   quota: "",
        //   assetsId: "",
        //   groupNums: "",
        //   couponType: "",
        //   memberType: "",
        // },
      ],
      // hongbaoyu
      awardSettingsLsit: [
        {
          prizeType: 1,
          price: null,
          title: "",
          singleAmount: null,
          totalAmount: "",
          inviteNum: null,
          takeEndTime: null,
          takeBeginTime: null,
          isMain: 1,
          quota: null,
        },
      ],
      echoDate: {},
      addCouponIsShow: false,
      // pageName:"忠诚度管理-优惠券管理",
      dialogFormVisible: false,
      tabActive: "1",
      totalList: 0,
      totalListTwo: 0,
      tableLoading: true,
      currentPage: 1,
      tableData: [],
      tableDataTwo: [],
      setFormList: {
        discount: "",
        endTime: "",
        name: "",
        quota: 0,
        shortUrl: "",
        startTime: "",
        url: "",
        takeBeginTime: "",
        takeEndTime: "",
        issueType: 0,
      },
      quota: "",
      formList: {
        current: 1,
        size: 10,
        isTake: 1,
        // isLink: true,
        // isFilter: true,
      },
      resource: "无条件", //添加外部优惠卷参加条件
      formListTwo: {
        current: 1,
        size: 10,
        isTake: 1,
      },
      inputData: [
        {
          name: "用户PIN:",
          val: "pin",
          placeholder: "请输入",
        },
        {
          name: "用户昵称:",
          val: "memberNick",
          placeholder: "请输入",
        },
        {
          name: "优惠券名称:",
          val: "couponName",
          placeholder: "请输入",
        },
        {
          name: "发放状态:",
          val: "sendStatus",
          placeholder: "请选择",
          selectArr: [
            { label: "发放成功", id: 0 },
            { label: "发放失败", id: 1 },
          ],
        },
        {
          name: "最后修改时间:",
          myDate: true,
          val: ["startTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
      ],
      TimeSendTimeOne1: 0, //有效期
      TimeSendTimeTwo1: 0, //领取时间
      inputDataTwo: [
        {
          name: "优惠券名称:",
          val: "name",
          placeholder: "请输入",
        },
        {
          name: "优惠券id/key:",
          val: "couponIdOrPutKey",
          placeholder: "请输入",
        },
        {
          name: "奖品状态:",
          val: "status",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "未开始", id: 1 },
            { label: "进行中", id: 2 },
            { label: "已结束", id: 3 },
          ],
        },
        {
          name: "优惠券使用范围:",
          val: "couponKind",
          placeholder: "请选择",
          selectArr: [
            { label: "全部", id: null },
            { label: "全店", id: 2 },
            { label: "商品", id: 3 },
            { label: "全品类", id: 0 },
            { label: "限品类", id: 1 },
          ],
        },
        {
          name: "创建时间:",
          myDate: true,
          val: ["beginTime", "endTime"],
          startPlaceholder: "开始日期",
          endPlaceholder: "结束日期",
          isdefault: true,
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      //   // this.quireList();
      //   console.log(this.$refs.inputForm);
      this.$refs.inputForms.formSearch();
    });
    this.estimate();
  },
  computed: {
    pageName: function() {
      if (this.tabActive == 1) {
        return "忠诚度管理-优惠券管理-内部优惠券";
      }
      if (this.tabActive == 2) {
        return "忠诚度管理-优惠券管理-外部优惠券";
      }
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    permissions() {
      // 权限列表
      return this.$store.getters.loginUserInfo.permissions;
    },
    dongCusExpiredIn() {
      // 【叶脉客服】工具或订购到期时间
      return this.$store.getters.loginUserInfo.dongCusExpiredIn;
    },
  },
  methods: {
    handleRelease(row) {
      this.$confirm("注:如释放的活动还有待发放奖品不建议释放库存", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        updateBindingStatus({
          prizeId: row.prizeId,
          bindingStatus: 1,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getRelActivityList();
          } else {
            this.$message.error(res.message);
          }
        }).catch(() => {
         
        });
      });
    },
    getRelActivityList() {
      this.loadingRel = true;
      queryBindingRecord({
        id: this.couponData.couponId,
        couponType: this.couponData.couponType,
      })
        .then((res) => {
          this.loadingRel = false;
          if (res.code == 1) {
            this.couponObj = res.data;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.loadingRel = false;
        });
    },
    marketNowActivity(row) {
      this.isShowAssociateActivity = true;
      this.couponData = row
      this.getRelActivityList();
    },
    syncDongdong(row) {
      if( this.dongCusExpiredIn == null || this.moment(this.dongCusExpiredIn).valueOf() < this.moment().valueOf() ){
        this.$message.error("当前店铺未订购【叶脉客服】工具或订购已到期，请订购后再操作或联系客服人员进行指引哦~");
        return;
      }
      let message =
        "同步后可在咚咚客服端-侧边栏-【叶脉客服】工具中使用，客服人员可直接进行发券，是否确认同步？";
      if (row.isMarkDong == "1") {
        message =
          "撤回后咚咚客服端-侧边栏-【叶脉客服】工具中不再显示该优惠券，是否确认撤回？";
      }
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            instance.confirmButtonLoading = true;
            let data = {
              ids: [row.id],
              type: row.isMarkDong == "1" ? "0" : "1",
            };
            sellerCouponWriteMarkDong(data)
              .then((res) => {
                instance.confirmButtonLoading = false;
                if (res.code == 1) {
                  done();
                  this.querySellerCouponExternal();
                  this.$message.success(
                    row.isMarkDong == "1" ? "撤回成功！" : "同步成功"
                  );
                } else {
                  this.$message.error(
                    row.isMarkDong == "1"
                      ? "撤回失败！失败原因：" + res.message
                      : "同步失败！失败原因：" + res.message
                  );
                }
              })
              .catch((err) => {
                console.log(err);
                instance.confirmButtonLoading = false;
              });
          } else {
            done();
          }
        },
      });
    },
    toZyCouponTeach() {
      window.open("https://www.yuque.com/yunduanxincrm/flgan6/mn0f6wect45lxa9v", "_blank");  
    },

    addStatus2() {
      // this.$refs.inputForm.formSearch();
      this.$refs.inputForms.formSearch();
    },
    commentDetails(item) {
      this.echoDate = item
      this.echoDate.numPerSending = item.numPerSending
      this.echoDate.days = item.addDays
      this.echoDate.bindType = item.couponKind == 2 ? 1 : 2
      this.addCouponIsShow = true
      this.showButton = false
    },
    handleAddCoupon() {
      this.addCouponIsShow = true
      this.echoDate = {}
      this.showButton = true
    },
    handleAddCoupon2() {
      this.addCouponIsShow2 = true
      this.echoDate2 = {}
      this.showButton2 = true
    },
    //pop店铺获取优惠券信息
    addStatus(val) {
      let obj = val
      createSellerCouponWrite(obj)
        .then((res) => {
          if (res && res.code == 1) {
            this.addCouponIsShow = false
            this.$message.success(res.message);
            this.$refs.inputForms.formSearch();
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {});
      // this.awardSettingsLsit[0].assetsId = data
      return
      if (this.isMain == 1) {
        this.awardSettingsLsit[0].innerCouponDto = val;
        this.awardSettingsLsit[0].quota = val.quota;
        this.awardSettingsLsit[0].beginTime = val.takeBeginTime;
        this.awardSettingsLsit[0].endTime = val.takeEndTime;
        this.awardSettingsLsit[0].totalAmount = val.num;
        this.awardSettingsLsit[0].title = val.name;
        this.awardSettingsLsit[0].price = val.discount;
        this.awardSettingsLsit[0].couponType = val.bindType;
        this.awardSettingsLsit[0].singleAmount = 1;
      } else {
        // if (this.superSplitCoupon) {
        //   this.FissionVoucherList[0].innerCouponDto = val;
        //   this.FissionVoucherList[0].quota = val.quota;
        //   this.FissionVoucherList[0].beginTime = val.takeBeginTime;
        //   this.FissionVoucherList[0].endTime = val.takeEndTime;
        //   this.FissionVoucherList[0].totalAmount = val.num;
        //   this.FissionVoucherList[0].title = val.name;
        //   this.FissionVoucherList[0].price = val.discount;
        //   this.FissionVoucherList[0].couponType = val.type;
        // } else {
        this.FissionVoucherList[this.indexCoupon].quota = val.quota;
        this.FissionVoucherList[this.indexCoupon].beginTime = val.takeBeginTime;
        this.FissionVoucherList[this.indexCoupon].endTime = val.takeEndTime;
        this.FissionVoucherList[this.indexCoupon].totalAmount = val.num;
        this.FissionVoucherList[this.indexCoupon].title = val.name;
        this.FissionVoucherList[this.indexCoupon].price = val.discount;
        this.FissionVoucherList[this.indexCoupon].couponType = val.bindType;
        this.FissionVoucherList[this.indexCoupon].innerCouponDto = val;
        this.FissionVoucherList[this.indexCoupon].singleAmount = 1;

        console.log(this.FissionVoucherList, 111111);
        // }
      }
    },
    handleClick(tab, event) {
      if (tab.name == "2") {
        this.insideBtn();
      } else {
        this.external();
      }
    },
    // aaa() {
    //   console.log(this.setFormList.resource);
    // },
    //计算领取时间时间
    TimeSendTimeOne() {
      if (this.setFormList.startTime != "" && this.setFormList.endTime != "") {
        const end = Date.parse(new Date(this.setFormList.endTime));
        const now = Date.parse(new Date(this.setFormList.startTime));
        if (end < now) {
          this.$message.error("选择时间错误");
          // this.clearTimeSendTime();
          this.setFormList.endTime = "";
          this.setFormList.startTime = "";
        } else {
          const msec = end - now;
          let time = parseInt(msec / 1000 / 60 / 60);
          let day = parseInt(msec / 1000 / 60 / 60 / 24);
          if (time < 24) {
            this.TimeSendTimeOne1 = 1;
          } else {
            this.TimeSendTimeOne1 = day;
          }
        }
      }
    },
    //计算时间
    TimeSendTimeTwo() {
      if (this.setFormList.takeBeginTime != "" && this.setFormList.takeEndTime != "") {
        const end = Date.parse(new Date(this.setFormList.takeEndTime));
        const now = Date.parse(new Date(this.setFormList.takeBeginTime));
        if (end < now) {
          this.$message.error("选择时间错误");
          // this.clearTimeSendTime();
          this.setFormList.takeEndTime = "";
          this.setFormList.takeBeginTime = "";
        } else {
          const msec = end - now;
          let time = parseInt(msec / 1000 / 60 / 60);
          let day = parseInt(msec / 1000 / 60 / 60 / 24);
          if (time < 24) {
            this.TimeSendTimeTwo1 = 1;
          } else {
            this.TimeSendTimeTwo1 = day;
          }
        }
      }
    },
    //判断是否跳转
    estimate() {
      // console.log(this.$route.query.length.to);
      console.log("this.$router", this.$route);
      if (this.$route.query.to != undefined) {
        this.tabActive = "2";
        // this.dataAtatisticsId = this.$route.query.to;
        // this.dataStatisticsContent.hotSaleId = this.dataAtatisticsId;
        this.querySellerCouponExternal();
      }
    },
    //参加条件变化
    resourceChange(val) {
      if (val == "无条件") {
        this.setFormList.quota = 0;
        this.quota = "";
      } else if (val == "订单满") {
        this.setFormList.quota = this.quota;
        console.log(this.quota);
      }
      console.log(this.setFormList.quota);
    },
    //pc端链接
    urlChange() {
      let path = this.setFormList.url.split("?");
      if (path.length == 1) {
        this.setFormList.shortUrl = `http://coupon.m.jd.com/coupons/show.action`;
      } else if (path.length == 2) {
        this.setFormList.shortUrl = `http://coupon.m.jd.com/coupons/show.action?${path[1]}`;
      }
    },
    //无线端链接
    shortUrlChange() {
      if (setFormList.url == "") {
        this.$message.warning("请输入Pc端链接");
        setFormList.shortUrl = "";
      }
    },
    //获取优惠券数据
    quireList() {
      console.log(this.formList,'list')
      this.tableLoading = true;
      couponSendRecord(this.formList).then((res) => {
        this.tableLoading = false;
        // console.log(res, "res");
        this.tableData = res.data.records;
        this.totalList = Number(res.data.total);
      });
    },
    //优惠券面额
    discountchange(val) {
      this.setFormList.discount = val.replace(/[^\d]/g, "");
    },
    //优惠券参加条件
    quotaChange(val) {
      this.quota = val.replace(/[^\d]/g, "");
    },
    moreStatistics() {
      window.open("https://prom.shop.jd.com/bdp/execute.action?queryConponData.couponId=131789594&bindType=1");
    },
    //查询外部优惠券信息
    querySellerCouponExternal() {
      this.tableLoading = true;
      console.log(this.formListTwo);
      querySellerCouponExternalList(this.formListTwo)
        .then((res) => {
          this.tableDataTwo = res.data.records;
          this.totalListTwo = Number(res.data.total);
          this.tableLoading = false;
        })
        .catch((res) => {});
    },
    //取消添加外部优惠
    closeWithoutCoupon() {
      this.dialogFormVisible = false;
      this.$message.warning("已取消添加外部优惠卷");
      this.clearAddCoupon();
    },
    clearAddCoupon() {
      this.setFormList = {
        discount: "",
        endTime: "",
        name: "",
        quota: 0,
        shortUrl: "",
        startTime: "",
        url: "",
        takeBeginTime: "",
        takeEndTime: "",
        putkey: "",
      };
      this.quota = "";
      this.TimeSendTimeOne1 = 0; //有效期
      this.TimeSendTimeTwo1 = 0; //领取时间
    },
    //确定添加外部优惠券
    addWithoutCoupon() {
      if (this.setFormList.issueType == 0) {
        if (this.resource == "订单满") {
          this.setFormList.quota = this.quota;
        }
        // return;
        this.addExternalOne();
      } else {
        this.addExternalOne1();
      }
    },
    //添加外部优惠券
    addExternalOne() {
      addExternal(this.setFormList)
        .then((res) => {
          if (res.code == 1) {
            this.dialogFormVisible = false;
            this.querySellerCouponExternal();
            this.clearAddCoupon();
            this.$message.success("添加成功");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    addExternalOne1() {
      let params = {
        putKey: this.setFormList.putKey,
        name: this.setFormList.name,
      };
      externalAuto(params)
        .then((res) => {
          if (res.code == 1) {
            this.dialogFormVisible = false;
            this.querySellerCouponExternal();
            this.clearAddCoupon();
            this.$message.success("添加成功");
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((res) => {
          this.$message.error(res.message);
        });
    },
    insideBtn() {
      this.tabActive = "2";
      // this.quireList();
      this.$nextTick(() => {
        console.log(this.$refs.inputForm);
        this.$refs.inputForm.initVal();
        this.$refs.inputForm.formSearch();
      });
    },
    external() {
      this.tabActive = "1";
      this.$nextTick(() => {
        console.log(this.$refs.inputForms);
        this.$refs.inputForms.initVal();
        this.$refs.inputForms.formSearch();
      });
      // setTimeout(()=>{
      // this.querySellerCouponExternal();

      // },500)
    },
    //内部优惠券查询
    searchContent(val) {
      // console.log(val, 111);
      // this.formList.current = "1";
      // this.formList.name = val.name;
      // this.formList.discount = val.discount;
      // this.formList.beginTime = val.beginTime;
      // this.formList.endTime = val.endTime;
      // this.formList.type = val.type;
      // this.formList.grantType = val.grantType;
      // this.formList.display = val.display;
      console.log(this.formList);
      var size = this.formList.size
      this.formList = {
        current: '1',
        ...val
      }
      this.formList.size = size
      // return
      this.quireList();
    },
    //外部优惠券查询
    searchContentTwo(val) {
      console.log(val);
      var size = this.formListTwo.size
      this.formListTwo = {
        current: '1',
        ...val
      }
      this.formListTwo.size = size
      // this.formListTwo.current = "1";
      // this.formListTwo.name = val.name;
      // this.formListTwo.discount = val.discount;
      // this.formListTwo.beginTime = val.beginTime;
      // this.formListTwo.endTime = val.endTime;
      // this.formListTwo.issueType = val.issueType;

      this.querySellerCouponExternal();
    },
    //创建
    setCoupon() {
      // console.log(1111);
      this.dialogFormVisible = true;
    },
    //分页变化事件
    handleSizeChange(val) {
      this.formList.size = val;
      this.quireList();
    },
    handleCurrentChange(val) {
      this.formList.current = val;
      this.quireList();
    },
    handleSizeChange2(val) {
      this.formListTwo.size = val;
      this.querySellerCouponExternal();
    },
    handleCurrentChange2(val) {
      this.formListTwo.current = val;
      this.querySellerCouponExternal();
    },
    clearTimeSendTime() {
      this.setFormList.startTime = "";
      this.setFormList.endTime = "";
      this.TimeSendTimeOne1 = 0;
    },
    clearTimeSendTime1() {
      this.setFormList.takeBeginTime = "";
      this.setFormList.takeEndTime = "";
      this.TimeSendTimeTwo1 = 0;
    },
    // 检测putKey可用性
    byPutKey() {
      byPutKey(this.setFormList.putKey).then((res) => {
        if (res.code == 1) {
          this.setFormList.endTime = res.data.endTime;
          this.setFormList.startTime = res.data.beginTime;
          this.setFormList.takeBeginTime = res.data.activityBeginTime;
          this.setFormList.takeEndTime = res.data.activityEndTime;
          this.setFormList.name = res.data.couponTitle;
          this.setFormList.discount = res.data.discount;
          this.setFormList.quota = res.data.quota;
          this.quota = res.data.quota;

          if (res.data.quota) {
            this.resource = "订单满";
          } else {
            this.resource = "无条件";
          }

          this.TimeSendTimeOne();
          this.TimeSendTimeTwo();

          this.$message.success("成功");
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 12px 0px 12px 20px;
  // display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("../../assets/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 26px;
      font-size: 14px;
      color: #333333;
      margin-left: 28px;
    }
  }
}
.integralEden {
  box-sizing: border-box;
  padding: 0 20px;
  min-width: 1110px;
  .content {
    // min-height: 980px;
    // margin: 20px 0 30px 0;
    background: rgba(255, 255, 255, 1);
    // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 6px;
    .navTab {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      padding: 0 20px;
      position: relative;
      height: 50px;
      font-size: 14px;
      color: #666;
      border-bottom: 1px solid #f6f6f6;
      .tab {
        height: 50px;
        line-height: 50px;
        position: relative;
        padding: 0 11px;
        cursor: pointer;
        transition: all 0.2s;
      }
      .active {
        color: #7b61ff;
        &::before {
          content: "";
          position: absolute;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 80%;
          height: 2px;
          background-color: #7b61ff;
          transition: all 0.2s;
          animation: opation 0.2s;
        }
      }
    }
    .pagination {
      margin: 40px 80px 0 0;
      text-align: right;
    }
  }
}
.operation {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #7b61ff;
  }
}
</style>
